import React, { useState , useRef} from 'react';
import emailjs from 'emailjs-com';


const ContactForm =(props) => {
  const form = useRef();
  let classDescription = "contact-container";

  if(props && props.view)
    classDescription =props.view + "-contact-container";
 
  function sendEmail(e) {
      e.preventDefault();
      let doc = document.getElementById("approval");
      if(doc !== null && doc.checked){
        emailjs.sendForm('service_cp-42213123', 'template_38aznh3', form.current, 'FXKQSlhQL2z2GlKwS')
        .then((result) => {
            window.location.reload() 
        }, (error) => {
            console.log(error.text);
        });
      }
  }

  return (
          <div className={classDescription}>
            <form ref={form} className="ui form" onSubmit={sendEmail}>
                  <div className="field">
                    <input type="text" name="user_name"  placeholder="Full Name" required/>
                  </div>
                  <div className="field">
                    <input type="text" name="phone_number"  maxLength={10} pattern="[6789][0-9]{9}" placeholder="Please enter a ten digit valid phone number" required/>
                  </div>
                  <div className="field">
                    <input type="text" name="user_email"  placeholder="Email Address" required/>
                  </div>
                  <div className="field">
                    <textarea rows="3" name="message"  placeholder="Message" required/>
                  </div>
                  <div className="field">
                    <div className="ui checkbox">
                      <input id="approval" type="checkbox" />
                      <label><p className="standard-text">I give <strong>Hygiene Systems</strong> permission to contact with me.</p></label>
                    </div>
                  </div>
                  <button className="ui fluid button" type="submit"><p className="standard-text">I would like to request information about the product</p></button>
            </form>
          </div>
  );
}

export default ContactForm